module.exports = __webpack_public_path__ + "static/img/weilai.4fd131a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weilai.png
// module id = tsYH
// module chunks = 24